import ImagesPreloader, { ImagesPreloaderProps } from "./ImagesPreloader";

export { ImagesPreloader, ImagesPreloaderProps };

export default ImagesPreloader;
